export const COUPON_TNC_HALF_CARD_CONTAINER_TEST_ID = "coupon-tnc-halfcard-container";
export const COUPON_TNC_HALF_CARD_COUPON_CARD_CONTAINER_TEST_ID = "coupon-tnc-halfcard-coupon-card-container";
export const COUPON_TNC_HALF_CARD_CTA_BUTTON_TEST_ID = "coupon-tnc-halfcard-cta-button";
export const COUPON_TNC_HALF_CARD_BULLET_POINT_ITEM_TEST_ID = "coupon-tnc-halfcard-bullet-point-item";
